module.exports = __webpack_public_path__ + "media/images/icons/vendors/webpic/photo-aefc972e15fc3ddfbfeb27b8f093b4f2.webp";